import emptyFunction from 'react-utils/emptyFunction';
import { useQuery } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';

// @ts-expect-error not converted to TS
import { Small } from 'UIComponents/elements';
import UILink from 'UIComponents/link/UILink';
import { flowRevisionUrl } from 'automation-ui-routing/workflowsUrls';
import UserName from 'automation-ui-references/customer-data/UserName';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import TrackableGeneric from 'automation-ui-usage-tracking/components/TrackableGeneric';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { FLOW_REVISION_FIELDNAME, GET_FLOW_REVISION_BY_TIMESTAMP } from 'automation-ui-log-events/api-client/queries/FlowRevisionQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RevisionLinkWithDetails = ({
  flowId,
  timestamp
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_FLOW_REVISION_BY_TIMESTAMP, {
    variables: {
      flowId,
      timestamp
    }
  });
  if (error) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-log-events.revisions.revisionLinkWithDetails.error"
    });
  }
  if (loading || !data) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  const flowRevision = data[FLOW_REVISION_FIELDNAME];
  const flow = flowRevision.flow;
  const updateMetadata = flow.updateMetadata;
  const revisionLink = /*#__PURE__*/_jsx(TrackableGeneric, {
    TrackedComponent: UILink,
    href: flowRevisionUrl(flowId, flowRevision.version),
    immediate: true,
    external: true,
    onClick: emptyFunction,
    trackableKey: Trackables.CLICKED_VIEW_WORKFLOW_REVISION,
    children: /*#__PURE__*/_jsx(FormattedDateTime, {
      value: updateMetadata.updatedAt,
      format: "lll",
      type: "portalTz"
    })
  });
  const updatedBy = updateMetadata.updatedBy;
  const revisionUpdatedBy = /*#__PURE__*/_jsx(Small, {
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-log-events.revisions.revisionLinkWithDetails.updatedBy",
      options: {
        userName: /*#__PURE__*/_jsx(UserName, {
          id: updatedBy && updatedBy.userId || ''
        })
      }
    })
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      children: revisionLink
    }), /*#__PURE__*/_jsx("div", {
      children: revisionUpdatedBy
    })]
  });
};
export default RevisionLinkWithDetails;